var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function DeleteIcon(props) {
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 20 });
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'delete', viewBox: "0 0 20 22" }, props),
        React.createElement("g", { id: "Delete", fill: "none", transform: "translate(1,1)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" },
            React.createElement("polyline", { id: "Path", points: "0 4 2 4 18 4" }),
            React.createElement("path", { d: "M16,4 L16,18 C16,19.1045695 15.1045695,20 14,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,4 M5,4 L5,2 C5,0.8954305 5.8954305,0 7,0 L11,0 C12.1045695,0 13,0.8954305 13,2 L13,4", id: "Shape" }),
            React.createElement("line", { x1: "7", y1: "9", x2: "7", y2: "15", id: "Path" }),
            React.createElement("line", { x1: "11", y1: "9", x2: "11", y2: "15", id: "Path" }))));
}
export default styled(DeleteIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
